import { render, staticRenderFns } from "./doubleFragmentTable.vue?vue&type=template&id=558cbbf8&scoped=true"
import script from "./doubleFragmentTable.vue?vue&type=script&lang=js"
export * from "./doubleFragmentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558cbbf8",
  null
  
)

export default component.exports